import {Component} from '@angular/core';

@Component({
    selector: 'tfl-outgoing-transfer-icon',
    template: require('./outgoing.html')
})
export class OutgoingTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/outgoing/outgoing.transfer.icon.ts